export enum MARKET_TYPE {
    Netherlands = "Netherlands",
    France = "France",
    UnitedKingdom = "UnitedKingdom",
    Germany = "Germany",
    Spain = "Spain",
    Global = "Global"
}

export const marketTypeOptions = [
    {label: 'Netherlands', value: MARKET_TYPE.Netherlands},
    {label: 'France', value: MARKET_TYPE.France},
    {label: 'United Kingdom', value: MARKET_TYPE.UnitedKingdom},
    {label: 'Germany', value: MARKET_TYPE.Germany},
    {label: 'Spain', value: MARKET_TYPE.Spain},
    {label: 'Global', value: MARKET_TYPE.Global}
];
